import styled, { css } from 'styled-components'

import { TypographyComponent } from '../../components/Typography'
import theme from '../../styles/theme'

export const ContainerFlex = styled('form')(
  () => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const Content = styled('div')(
  () => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 80%;

    @media (max-width: ${theme.screen.large}) {
      width: 100%;
    }
  `
)

export const Title = styled('h1')(
  () => css`
    font-size: ${theme.typograph.fontsize.h8};
  `
)

export const Typography = styled(TypographyComponent)(
  () => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
      font-weight: 300;

      span {
        font-weight: 700;
      }
    }
  `
)

export const ContainerImage = styled('div')(
  () => css`
    @media (max-width: ${theme.screen.medium}) {
      display: none;
    }
  `
)

export const ModalBoxButtons = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: ${theme.layout.gap.medium};
    margin-top: ${theme.layout.margin.base * 6}rem;
  `
)
